import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ec2-user/ennix-electronics/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/ennix-electronics/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/ennix-electronics/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"600\",\"700\"],\"display\":\"swap\",\"variable\":\"--font-inter\",\"adjustFontFallback\":true,\"preload\":true}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ClarityTracker"] */ "/home/ec2-user/ennix-electronics/src/_components/ClarityTracker.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/ennix-electronics/src/_components/FooterQueryOverlay.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalErrorHandler"] */ "/home/ec2-user/ennix-electronics/src/_components/GlobalErrorHandler.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleOneTap"] */ "/home/ec2-user/ennix-electronics/src/_components/GoogleOneTap.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/ec2-user/ennix-electronics/src/_components/header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileBottomNav"] */ "/home/ec2-user/ennix-electronics/src/_components/MobileBottomNav.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["OffersAlertBarClient"] */ "/home/ec2-user/ennix-electronics/src/_components/OffersAlertBarClient.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrimeProvider"] */ "/home/ec2-user/ennix-electronics/src/_components/PrimeProvider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreConfigProvider"] */ "/home/ec2-user/ennix-electronics/src/_context/StoreConfigContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/ennix-electronics/src/app/cleartyAnalytic.js");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTop"] */ "/home/ec2-user/ennix-electronics/src/app/scrollToTop.js");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/ennix-electronics/src/styles/globals.scss");
